export enum EnrollmentProgram {
    other = 10,
    otherNH = 45
}
